import { useEffect } from 'react';

import { useForceUpdate } from '@spazious/react-hooks';

import { useStore } from './useStore.js';

export const useHistory = () => {
  const history = useStore(({ history }) => history);

  const forceUpdate = useForceUpdate();
  useEffect(
    () =>
      history.subscribe(() => {
        forceUpdate();
      }),
    [forceUpdate, history]
  );

  return history;
};

export default useHistory;
